import { z } from 'zod';

// Zod Schema for Stats
const StatsSchema = z.object({
  symbol: z.string(),
  datetime: z.number(),
  bid_high: z.number(),
  bid_low: z.number(),
  ask_high: z.number(),
  ask_low: z.number(),
  datetime_msc: z.number()
});

// Zod Schema for SymbolInfo (RootInterface)
const SymbolInfoSchema = z.object({
  symbol: z.string(),
  logo: z.string(),
  full_name: z.string(),
  exchange: z.string(),
  description: z.string(),
  type: z.string(),
  digit: z.number(),
  company_name: z.string(),
  currency_margin: z.string(),
  contract_size: z.number(),
  volume_max: z.number(),
  volume_min: z.number(),
  stops_level: z.number(),
  exec_mode: z.number(),
  trade_mode: z.number(),
  volume_step: z.number(),
  calc_mode: z.number(),
  currency_base: z.string(),
  currency_profit: z.string(),
  currency_margin_digits: z.number(),
  currency_profit_digits: z.number(),
  stats: StatsSchema
});

export { SymbolInfoSchema, StatsSchema }